import $ from 'jquery';
import ThumbBoard from './thumb_board';
import { makeAjaxRequestUri } from './utils';
import toThumbBoardItemFormat from './converter';
import ButtonExtend from './button_extend';

const defaultConfig = {
  isImageDataEnd: false,
  thumbBoard: {},
};

function ImageApp($appTarget, config) {
  this.$app = $appTarget;
  this.config = $.extend({}, defaultConfig, config);
  this.state = {
    dataPageNum: 1,
    ajaxRequestCount: 0,
    moreBtnClickCnt: 0, // 통검용 펼쳐보기 카운트 (이 값으로 4번 이후 접기 동작을 제어한다.), -> 2014.05.28, 탭 80건 노출로 펼쳐보기 1회 줄임
    visibleLine: 0, // 통검용 라인 트래킹 카운트
    totalAjaxRequestCnt: 0, // 총 ajax 카운트
    isImageDataEnd: this.config.isImageDataEnd,
    isUserReportMode: window.SF.getParam('cnucc') === '1',
    preventAjaxCall: false,
    reachedAjaxCallLimit: false,
    resizeStart: 0
  };

  // Core Components
  this.thumbBoard = new ThumbBoard(this.config.data, $appTarget, this.config.thumbBoard, this.state);
  this.$loadingSpinner = this.config.loadingSpinner ? $(this.config.loadingSpinner) : null;
  this.btnExtend = this.config.buttonExtendSelector ? new ButtonExtend(this.$app, this.config.buttonExtendSelector) : null;

  this.init();
}

ImageApp.prototype = {
  fetchData(params) {
    const url = makeAjaxRequestUri(params);
    return $.ajax(url, {
      method: 'GET',
      timeout: 2500
    }).then((data) => {
      return typeof data === 'string' ? $.parseJSON(data) : data;
    }).fail(() => {
      this.showLoadingSpinner(false);
    });
  },

  showLoadingSpinner(show) {
    show ? this.$app.trigger('load:start') : this.$app.trigger('load:end');
    if (!this.$loadingSpinner){
      return;
    }
    show ? this.$loadingSpinner.show() : this.$loadingSpinner.hide();
  },

  getMoreData(params, eventType) {
    if (eventType === 'click') {
      this.state.ajaxRequestCount = 0;
    }
    this.state.ajaxRequestCount++;
    this.state.preventAjaxCall = true;
    this.showLoadingSpinner(true);
    return this.fetchData(params).then((data) => {
      let ds = '';
      let isEnd = false;
      let endType = '';

      try {
        const spreadImage = data.RESULT.SPREAD_TAB_IMAGE || data.RESULT.SPREAD_IMAGE;
        ds = spreadImage.r.ds;
        isEnd = spreadImage.r.m.is_end.toLowerCase() === 'true';
        endType = spreadImage.r.m.endType;
      } catch (e) {
        // 로딩 이미지 숨김.
        this.showLoadingSpinner(false);
        return;
      }

      const hasData = typeof ds !== 'string';

      if (!hasData) {
        return;
      }

      if (isEnd) {
        this.state.isImageDataEnd = true;
        this.$app.trigger({
          type: 'data:end',
          endType
        });
      }
      this.state.totalAjaxRequestCnt++;
      this.state.dataPageNum++;
      const refinedData = toThumbBoardItemFormat(ds);
      this.thumbBoard.updateData(refinedData, (startIdx) => {
        this.thumbBoard.renderImages(startIdx);
        this.thumbBoard.resizeImages();
        SF.userReportExec && SF.userReportExec.init();
      });
      this.showLoadingSpinner(false);
    });
  },

  /**
   * 내려받은 이미지 전체의 크기값을 재연산 한다
   * @param callback
   */
  refresh(callback) {
    this.thumbBoard.setImageDiv();
    this.thumbBoard.resizeImages();
    if (callback) {
      callback();
    }
  },

  init() {
    // $app에 이벤트 리스너를 달려면 thumboard에서 데이터를 가공하고 render 이벤트를 emit 하는 시점이 event loop 뒤로 가야함
    setTimeout(() => {
      this.thumbBoard.init();
    }, 0);
  }
};

export default ImageApp;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/app.js
 **/